if (!customElements.get("footer-details")) {
  class FooterDetails extends AccordionDetails {
    constructor() {
      super();
    }
    
    connectedCallback() {
      this.openDefault = this.dataset.openDefault === 'true';

      if (FoxTheme.config.mqlTablet) {
        if (!this.openDefault) this.open = false;
      }

      document.addEventListener('matchTablet', () => {
        if (!this.openDefault) {
          this.open = false;
        } else {
          this.open = true;
        }
      });

      document.addEventListener('unmatchTablet', () => {
        this.open = true;
      });
    }
  }
  customElements.define('footer-details', FooterDetails, { extends: 'details' });
}

document.addEventListener('DOMContentLoaded', () => {
  const btn = document.querySelector('.footer__language-btn');
  const list = document.querySelector('.footer__language-list');

  if (btn && list) {
    btn.addEventListener('click', () => {
      const expanded = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', !expanded);
      list.style.display = expanded ? 'none' : 'block';
    });

    document.addEventListener('click', (e) => {
      if (!e.target.closest('.footer__language')) {
        list.style.display = 'none';
        btn.setAttribute('aria-expanded', 'false');
      }
    });
  }
});

// Cookie settings: reopen the Consentmo preferences dialog
document.addEventListener('click', function (e) {
  const link = e.target.closest('a[href$="#cookie-settings"]');
  if (!link) return;
  e.preventDefault();
  if (window.Consentmo) {
    window.Consentmo.openDialog('preferences');
  }
});